/* tslint:disable */
/* eslint-disable */
/**
 * data-pusher-app API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 6.6.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface ActionDTO
 */
export interface ActionDTO {
    /**
     * 
     * @type {string}
     * @memberof ActionDTO
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionDTO
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionDTO
     */
    'description'?: string;
    /**
     * 
     * @type {any}
     * @memberof ActionDTO
     */
    'returnSchema'?: any;
    /**
     * 
     * @type {Array<ArgumentInfoDTO>}
     * @memberof ActionDTO
     */
    'arguments'?: Array<ArgumentInfoDTO>;
}
/**
 * 
 * @export
 * @interface ArgumentInfoDTO
 */
export interface ArgumentInfoDTO {
    /**
     * 
     * @type {string}
     * @memberof ArgumentInfoDTO
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArgumentInfoDTO
     */
    'description'?: string;
    /**
     * 
     * @type {any}
     * @memberof ArgumentInfoDTO
     */
    'argumentSchema'?: any;
}
/**
 * 
 * @export
 * @interface BackupEntry
 */
export interface BackupEntry {
    /**
     * 
     * @type {number}
     * @memberof BackupEntry
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BackupEntry
     */
    'readerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BackupEntry
     */
    'timestamp'?: string;
    /**
     * 
     * @type {UserInfo}
     * @memberof BackupEntry
     */
    'editor'?: UserInfo;
}
/**
 * 
 * @export
 * @interface BasicPipelineInfo
 */
export interface BasicPipelineInfo {
    /**
     * 
     * @type {boolean}
     * @memberof BasicPipelineInfo
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BasicPipelineInfo
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BasicPipelineInfo
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BasicPipelineInfo
     */
    'inputSchemaTypes'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BasicPipelineInfo
     */
    'processingSchemaType'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BasicPipelineInfo
     */
    'outputSchemaTypes'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BasicPipelineInfo
     */
    'lastModified'?: string;
}
/**
 * 
 * @export
 * @interface DataPoint
 */
export interface DataPoint {
    /**
     * 
     * @type {string}
     * @memberof DataPoint
     */
    'ts'?: string;
    /**
     * 
     * @type {number}
     * @memberof DataPoint
     */
    'v'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const LogLevel = {
    Off: 'OFF',
    Severe: 'SEVERE',
    Warning: 'WARNING',
    Info: 'INFO',
    Config: 'CONFIG',
    Fine: 'FINE',
    Finer: 'FINER',
    Finest: 'FINEST',
    All: 'ALL'
} as const;

export type LogLevel = typeof LogLevel[keyof typeof LogLevel];


/**
 * 
 * @export
 * @interface LogMessage
 */
export interface LogMessage {
    /**
     * 
     * @type {string}
     * @memberof LogMessage
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogMessage
     */
    'loggerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogMessage
     */
    'className'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogMessage
     */
    'methodName'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogMessage
     */
    'levelInt'?: number;
    /**
     * 
     * @type {string}
     * @memberof LogMessage
     */
    'level'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogMessage
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LogMessage
     */
    'hasException'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LogMessage
     */
    'exceptionType'?: string;
}
/**
 * 
 * @export
 * @interface LogRequest
 */
export interface LogRequest {
    /**
     * 
     * @type {string}
     * @memberof LogRequest
     */
    'from'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogRequest
     */
    'to'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogRequest
     */
    'duration'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogRequest
     */
    'limit'?: number;
    /**
     * 
     * @type {LogLevel}
     * @memberof LogRequest
     */
    'minLevel'?: LogLevel;
    /**
     * 
     * @type {boolean}
     * @memberof LogRequest
     */
    'requireException'?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof LogRequest
     */
    'likeRequests'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof LogRequest
     */
    'equalRequests'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof LogRequest
     */
    'regexRequests'?: { [key: string]: string; };
}


/**
 * 
 * @export
 * @interface ProtocolDescription
 */
export interface ProtocolDescription {
    /**
     * 
     * @type {string}
     * @memberof ProtocolDescription
     */
    'implementationKey': string;
    /**
     * 
     * @type {SchemaType}
     * @memberof ProtocolDescription
     */
    'schemaType': SchemaType;
    /**
     * 
     * @type {string}
     * @memberof ProtocolDescription
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProtocolDescription
     */
    'description': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const SchemaType = {
    Input: 'INPUT',
    Processing: 'PROCESSING',
    Output: 'OUTPUT'
} as const;

export type SchemaType = typeof SchemaType[keyof typeof SchemaType];


/**
 * 
 * @export
 * @interface UserInfo
 */
export interface UserInfo {
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    'username'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserInfo
     */
    'userCompanies'?: Array<string>;
}
/**
 * 
 * @export
 * @interface VersionInfo
 */
export interface VersionInfo {
    /**
     * 
     * @type {string}
     * @memberof VersionInfo
     */
    'version'?: string;
    /**
     * 
     * @type {string}
     * @memberof VersionInfo
     */
    'buildTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof VersionInfo
     */
    'buildId'?: string;
}

/**
 * ActionsApi - axios parameter creator
 * @export
 */
export const ActionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get actions for schema
         * @param {string} schema 
         * @param {SchemaType} schemaType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActions: async (schema: string, schemaType: SchemaType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('getActions', 'schema', schema)
            // verify required parameter 'schemaType' is not null or undefined
            assertParamExists('getActions', 'schemaType', schemaType)
            const localVarPath = `/actions/{schemaType}/{schema}`
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)))
                .replace(`{${"schemaType"}}`, encodeURIComponent(String(schemaType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Invoke action
         * @param {string} aPipelineId 
         * @param {SchemaType} bSchemaType 
         * @param {string} cPartId 
         * @param {string} dActionId 
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invokeAction: async (aPipelineId: string, bSchemaType: SchemaType, cPartId: string, dActionId: string, body: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aPipelineId' is not null or undefined
            assertParamExists('invokeAction', 'aPipelineId', aPipelineId)
            // verify required parameter 'bSchemaType' is not null or undefined
            assertParamExists('invokeAction', 'bSchemaType', bSchemaType)
            // verify required parameter 'cPartId' is not null or undefined
            assertParamExists('invokeAction', 'cPartId', cPartId)
            // verify required parameter 'dActionId' is not null or undefined
            assertParamExists('invokeAction', 'dActionId', dActionId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('invokeAction', 'body', body)
            const localVarPath = `/actions/invoke/{a_pipelineId}/{b_schemaType}/{c_partId}/{d_actionId}`
                .replace(`{${"a_pipelineId"}}`, encodeURIComponent(String(aPipelineId)))
                .replace(`{${"b_schemaType"}}`, encodeURIComponent(String(bSchemaType)))
                .replace(`{${"c_partId"}}`, encodeURIComponent(String(cPartId)))
                .replace(`{${"d_actionId"}}`, encodeURIComponent(String(dActionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActionsApi - functional programming interface
 * @export
 */
export const ActionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get actions for schema
         * @param {string} schema 
         * @param {SchemaType} schemaType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActions(schema: string, schemaType: SchemaType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActionDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActions(schema, schemaType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionsApi.getActions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Invoke action
         * @param {string} aPipelineId 
         * @param {SchemaType} bSchemaType 
         * @param {string} cPartId 
         * @param {string} dActionId 
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invokeAction(aPipelineId: string, bSchemaType: SchemaType, cPartId: string, dActionId: string, body: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invokeAction(aPipelineId, bSchemaType, cPartId, dActionId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionsApi.invokeAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActionsApi - factory interface
 * @export
 */
export const ActionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get actions for schema
         * @param {string} schema 
         * @param {SchemaType} schemaType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActions(schema: string, schemaType: SchemaType, options?: RawAxiosRequestConfig): AxiosPromise<Array<ActionDTO>> {
            return localVarFp.getActions(schema, schemaType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Invoke action
         * @param {string} aPipelineId 
         * @param {SchemaType} bSchemaType 
         * @param {string} cPartId 
         * @param {string} dActionId 
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invokeAction(aPipelineId: string, bSchemaType: SchemaType, cPartId: string, dActionId: string, body: any, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.invokeAction(aPipelineId, bSchemaType, cPartId, dActionId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActionsApi - object-oriented interface
 * @export
 * @class ActionsApi
 * @extends {BaseAPI}
 */
export class ActionsApi extends BaseAPI {
    /**
     * 
     * @summary Get actions for schema
     * @param {string} schema 
     * @param {SchemaType} schemaType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    public getActions(schema: string, schemaType: SchemaType, options?: RawAxiosRequestConfig) {
        return ActionsApiFp(this.configuration).getActions(schema, schemaType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Invoke action
     * @param {string} aPipelineId 
     * @param {SchemaType} bSchemaType 
     * @param {string} cPartId 
     * @param {string} dActionId 
     * @param {any} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionsApi
     */
    public invokeAction(aPipelineId: string, bSchemaType: SchemaType, cPartId: string, dActionId: string, body: any, options?: RawAxiosRequestConfig) {
        return ActionsApiFp(this.configuration).invokeAction(aPipelineId, bSchemaType, cPartId, dActionId, body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BackupApi - axios parameter creator
 * @export
 */
export const BackupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Backup
         * @param {string} readerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBackup: async (readerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'readerId' is not null or undefined
            assertParamExists('createBackup', 'readerId', readerId)
            const localVarPath = `/backup/backup/{readerId}`
                .replace(`{${"readerId"}}`, encodeURIComponent(String(readerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Remote Backup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRemoteBackup: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/backup/createRemoteBackup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Backup
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBackup: async (ids: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteBackup', 'ids', ids)
            const localVarPath = `/backup/backup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Backups
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBackups: async (ids?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/backup/entries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Configuration Backup
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationBackup: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getConfigurationBackup', 'id', id)
            const localVarPath = `/backup/backup/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Restore Backup
         * @param {string} readerId 
         * @param {number} backupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreBackup: async (readerId: string, backupId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'readerId' is not null or undefined
            assertParamExists('restoreBackup', 'readerId', readerId)
            // verify required parameter 'backupId' is not null or undefined
            assertParamExists('restoreBackup', 'backupId', backupId)
            const localVarPath = `/backup/restore/{readerId}`
                .replace(`{${"readerId"}}`, encodeURIComponent(String(readerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (backupId !== undefined) {
                localVarQueryParameter['backupId'] = backupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BackupApi - functional programming interface
 * @export
 */
export const BackupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BackupApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Backup
         * @param {string} readerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBackup(readerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBackup(readerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackupApi.createBackup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Remote Backup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRemoteBackup(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRemoteBackup(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackupApi.createRemoteBackup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Backup
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBackup(ids: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBackup(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackupApi.deleteBackup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Backups
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBackups(ids?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BackupEntry>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBackups(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackupApi.getBackups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Configuration Backup
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfigurationBackup(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfigurationBackup(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackupApi.getConfigurationBackup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Restore Backup
         * @param {string} readerId 
         * @param {number} backupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreBackup(readerId: string, backupId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreBackup(readerId, backupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackupApi.restoreBackup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BackupApi - factory interface
 * @export
 */
export const BackupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BackupApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Backup
         * @param {string} readerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBackup(readerId: string, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.createBackup(readerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Remote Backup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRemoteBackup(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createRemoteBackup(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Backup
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBackup(ids: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteBackup(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Backups
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBackups(ids?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<BackupEntry>> {
            return localVarFp.getBackups(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Configuration Backup
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationBackup(id: number, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getConfigurationBackup(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Restore Backup
         * @param {string} readerId 
         * @param {number} backupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreBackup(readerId: string, backupId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.restoreBackup(readerId, backupId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BackupApi - object-oriented interface
 * @export
 * @class BackupApi
 * @extends {BaseAPI}
 */
export class BackupApi extends BaseAPI {
    /**
     * 
     * @summary Create Backup
     * @param {string} readerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public createBackup(readerId: string, options?: RawAxiosRequestConfig) {
        return BackupApiFp(this.configuration).createBackup(readerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Remote Backup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public createRemoteBackup(options?: RawAxiosRequestConfig) {
        return BackupApiFp(this.configuration).createRemoteBackup(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Backup
     * @param {Array<number>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public deleteBackup(ids: Array<number>, options?: RawAxiosRequestConfig) {
        return BackupApiFp(this.configuration).deleteBackup(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Backups
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public getBackups(ids?: Array<string>, options?: RawAxiosRequestConfig) {
        return BackupApiFp(this.configuration).getBackups(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Configuration Backup
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public getConfigurationBackup(id: number, options?: RawAxiosRequestConfig) {
        return BackupApiFp(this.configuration).getConfigurationBackup(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Restore Backup
     * @param {string} readerId 
     * @param {number} backupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public restoreBackup(readerId: string, backupId: number, options?: RawAxiosRequestConfig) {
        return BackupApiFp(this.configuration).restoreBackup(readerId, backupId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DataApi - axios parameter creator
 * @export
 */
export const DataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Input History
         * @param {string} key 
         * @param {string} pipeline 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInputHistory: async (key: string, pipeline: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getInputHistory', 'key', key)
            // verify required parameter 'pipeline' is not null or undefined
            assertParamExists('getInputHistory', 'pipeline', pipeline)
            const localVarPath = `/data/{pipeline}/inputHistory/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)))
                .replace(`{${"pipeline"}}`, encodeURIComponent(String(pipeline)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Latest Inputs
         * @param {string} pipeline 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestInputs: async (pipeline: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipeline' is not null or undefined
            assertParamExists('getLatestInputs', 'pipeline', pipeline)
            const localVarPath = `/data/{pipeline}/latestInputs`
                .replace(`{${"pipeline"}}`, encodeURIComponent(String(pipeline)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Output
         * @param {string} pipeline 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestOutputs: async (pipeline: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipeline' is not null or undefined
            assertParamExists('getLatestOutputs', 'pipeline', pipeline)
            const localVarPath = `/data/{pipeline}/latestOutputs`
                .replace(`{${"pipeline"}}`, encodeURIComponent(String(pipeline)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Output History
         * @param {string} key 
         * @param {string} pipeline 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutputHistory: async (key: string, pipeline: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getOutputHistory', 'key', key)
            // verify required parameter 'pipeline' is not null or undefined
            assertParamExists('getOutputHistory', 'pipeline', pipeline)
            const localVarPath = `/data/{pipeline}/outputHistory/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)))
                .replace(`{${"pipeline"}}`, encodeURIComponent(String(pipeline)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataApi - functional programming interface
 * @export
 */
export const DataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Input History
         * @param {string} key 
         * @param {string} pipeline 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInputHistory(key: string, pipeline: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataPoint>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInputHistory(key, pipeline, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.getInputHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Latest Inputs
         * @param {string} pipeline 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestInputs(pipeline: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: DataPoint; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestInputs(pipeline, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.getLatestInputs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Output
         * @param {string} pipeline 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestOutputs(pipeline: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: DataPoint; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestOutputs(pipeline, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.getLatestOutputs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Output History
         * @param {string} key 
         * @param {string} pipeline 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOutputHistory(key: string, pipeline: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataPoint>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOutputHistory(key, pipeline, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.getOutputHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DataApi - factory interface
 * @export
 */
export const DataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Input History
         * @param {string} key 
         * @param {string} pipeline 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInputHistory(key: string, pipeline: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DataPoint>> {
            return localVarFp.getInputHistory(key, pipeline, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Latest Inputs
         * @param {string} pipeline 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestInputs(pipeline: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: DataPoint; }> {
            return localVarFp.getLatestInputs(pipeline, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Output
         * @param {string} pipeline 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestOutputs(pipeline: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: DataPoint; }> {
            return localVarFp.getLatestOutputs(pipeline, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Output History
         * @param {string} key 
         * @param {string} pipeline 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutputHistory(key: string, pipeline: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DataPoint>> {
            return localVarFp.getOutputHistory(key, pipeline, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataApi - object-oriented interface
 * @export
 * @class DataApi
 * @extends {BaseAPI}
 */
export class DataApi extends BaseAPI {
    /**
     * 
     * @summary Get Input History
     * @param {string} key 
     * @param {string} pipeline 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataApi
     */
    public getInputHistory(key: string, pipeline: string, options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).getInputHistory(key, pipeline, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Latest Inputs
     * @param {string} pipeline 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataApi
     */
    public getLatestInputs(pipeline: string, options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).getLatestInputs(pipeline, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Output
     * @param {string} pipeline 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataApi
     */
    public getLatestOutputs(pipeline: string, options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).getLatestOutputs(pipeline, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Output History
     * @param {string} key 
     * @param {string} pipeline 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataApi
     */
    public getOutputHistory(key: string, pipeline: string, options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).getOutputHistory(key, pipeline, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LogsApi - axios parameter creator
 * @export
 */
export const LogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get log of data collector instance
         * @summary Get General Log
         * @param {LogRequest} logRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneralLog: async (logRequest: LogRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logRequest' is not null or undefined
            assertParamExists('getGeneralLog', 'logRequest', logRequest)
            const localVarPath = `/logs/general`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get log of pipeline. Any provided \"loggerNameRegex\" is ignored
         * @summary Get Reader Log
         * @param {string} pipelineId 
         * @param {LogRequest} logRequest 
         * @param {boolean} [input] 
         * @param {boolean} [output] 
         * @param {boolean} [pipeline] 
         * @param {boolean} [processor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineLog: async (pipelineId: string, logRequest: LogRequest, input?: boolean, output?: boolean, pipeline?: boolean, processor?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('getPipelineLog', 'pipelineId', pipelineId)
            // verify required parameter 'logRequest' is not null or undefined
            assertParamExists('getPipelineLog', 'logRequest', logRequest)
            const localVarPath = `/logs/pipeline/{pipelineId}`
                .replace(`{${"pipelineId"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (input !== undefined) {
                localVarQueryParameter['input'] = input;
            }

            if (output !== undefined) {
                localVarQueryParameter['output'] = output;
            }

            if (pipeline !== undefined) {
                localVarQueryParameter['pipeline'] = pipeline;
            }

            if (processor !== undefined) {
                localVarQueryParameter['processor'] = processor;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LogsApi - functional programming interface
 * @export
 */
export const LogsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LogsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get log of data collector instance
         * @summary Get General Log
         * @param {LogRequest} logRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeneralLog(logRequest: LogRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LogMessage>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeneralLog(logRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogsApi.getGeneralLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get log of pipeline. Any provided \"loggerNameRegex\" is ignored
         * @summary Get Reader Log
         * @param {string} pipelineId 
         * @param {LogRequest} logRequest 
         * @param {boolean} [input] 
         * @param {boolean} [output] 
         * @param {boolean} [pipeline] 
         * @param {boolean} [processor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPipelineLog(pipelineId: string, logRequest: LogRequest, input?: boolean, output?: boolean, pipeline?: boolean, processor?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LogMessage>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPipelineLog(pipelineId, logRequest, input, output, pipeline, processor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogsApi.getPipelineLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LogsApi - factory interface
 * @export
 */
export const LogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LogsApiFp(configuration)
    return {
        /**
         * Get log of data collector instance
         * @summary Get General Log
         * @param {LogRequest} logRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneralLog(logRequest: LogRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<LogMessage>> {
            return localVarFp.getGeneralLog(logRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get log of pipeline. Any provided \"loggerNameRegex\" is ignored
         * @summary Get Reader Log
         * @param {string} pipelineId 
         * @param {LogRequest} logRequest 
         * @param {boolean} [input] 
         * @param {boolean} [output] 
         * @param {boolean} [pipeline] 
         * @param {boolean} [processor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineLog(pipelineId: string, logRequest: LogRequest, input?: boolean, output?: boolean, pipeline?: boolean, processor?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<LogMessage>> {
            return localVarFp.getPipelineLog(pipelineId, logRequest, input, output, pipeline, processor, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LogsApi - object-oriented interface
 * @export
 * @class LogsApi
 * @extends {BaseAPI}
 */
export class LogsApi extends BaseAPI {
    /**
     * Get log of data collector instance
     * @summary Get General Log
     * @param {LogRequest} logRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogsApi
     */
    public getGeneralLog(logRequest: LogRequest, options?: RawAxiosRequestConfig) {
        return LogsApiFp(this.configuration).getGeneralLog(logRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get log of pipeline. Any provided \"loggerNameRegex\" is ignored
     * @summary Get Reader Log
     * @param {string} pipelineId 
     * @param {LogRequest} logRequest 
     * @param {boolean} [input] 
     * @param {boolean} [output] 
     * @param {boolean} [pipeline] 
     * @param {boolean} [processor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogsApi
     */
    public getPipelineLog(pipelineId: string, logRequest: LogRequest, input?: boolean, output?: boolean, pipeline?: boolean, processor?: boolean, options?: RawAxiosRequestConfig) {
        return LogsApiFp(this.configuration).getPipelineLog(pipelineId, logRequest, input, output, pipeline, processor, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ManagementApi - axios parameter creator
 * @export
 */
export const ManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Empty Config
         * @param {string} schema 
         * @param {SchemaType} schemaType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmptyConfig: async (schema: string, schemaType: SchemaType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('createEmptyConfig', 'schema', schema)
            // verify required parameter 'schemaType' is not null or undefined
            assertParamExists('createEmptyConfig', 'schemaType', schemaType)
            const localVarPath = `/management/emptyConfig/{schemaType}/{schema}`
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)))
                .replace(`{${"schemaType"}}`, encodeURIComponent(String(schemaType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Pipeline
         * @param {string} pipelineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePipeline: async (pipelineId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('deletePipeline', 'pipelineId', pipelineId)
            const localVarPath = `/management/{pipelineId}`
                .replace(`{${"pipelineId"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Does Pipeline Exist
         * @param {string} pipelineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doesPipelineExist: async (pipelineId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('doesPipelineExist', 'pipelineId', pipelineId)
            const localVarPath = `/management/exists/{pipelineId}`
                .replace(`{${"pipelineId"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get All Schemas
         * @param {SchemaType} schemaType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSchemas: async (schemaType: SchemaType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schemaType' is not null or undefined
            assertParamExists('getAllSchemas', 'schemaType', schemaType)
            const localVarPath = `/management/allSchemas/{schemaType}`
                .replace(`{${"schemaType"}}`, encodeURIComponent(String(schemaType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Pipeline Config
         * @param {string} pipelineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineConfig: async (pipelineId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('getPipelineConfig', 'pipelineId', pipelineId)
            const localVarPath = `/management/config/{pipelineId}`
                .replace(`{${"pipelineId"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Pipeline Config Editor
         * @param {string} pipelineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineConfigEditor: async (pipelineId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('getPipelineConfigEditor', 'pipelineId', pipelineId)
            const localVarPath = `/management/editor/{pipelineId}`
                .replace(`{${"pipelineId"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Pipelines
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelines: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/management/pipelines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Schema
         * @param {string} schema 
         * @param {SchemaType} schemaType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchema: async (schema: string, schemaType: SchemaType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('getSchema', 'schema', schema)
            // verify required parameter 'schemaType' is not null or undefined
            assertParamExists('getSchema', 'schemaType', schemaType)
            const localVarPath = `/management/schema/{schemaType}/{schema}`
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)))
                .replace(`{${"schemaType"}}`, encodeURIComponent(String(schemaType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Supported Meter Types
         * @param {SchemaType} schemaType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedMeterTypes: async (schemaType: SchemaType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schemaType' is not null or undefined
            assertParamExists('getSupportedMeterTypes', 'schemaType', schemaType)
            const localVarPath = `/management/supportedMeterTypes/{schemaType}`
                .replace(`{${"schemaType"}}`, encodeURIComponent(String(schemaType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Parse Config
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseConfig: async (body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('parseConfig', 'body', body)
            const localVarPath = `/management/parseConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reload All
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reloadAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/management/reloadAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reload Pipeline
         * @param {string} pipelineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reloadPipeline: async (pipelineId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('reloadPipeline', 'pipelineId', pipelineId)
            const localVarPath = `/management/reload/{pipelineId}`
                .replace(`{${"pipelineId"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set Pipeline Config
         * @param {string} pipelineId 
         * @param {string} body 
         * @param {string} [expectedModifiedTs] 
         * @param {boolean} [requireExist] 
         * @param {boolean} [requireNotExist] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPipelineConfig: async (pipelineId: string, body: string, expectedModifiedTs?: string, requireExist?: boolean, requireNotExist?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('setPipelineConfig', 'pipelineId', pipelineId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('setPipelineConfig', 'body', body)
            const localVarPath = `/management/{pipelineId}`
                .replace(`{${"pipelineId"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (expectedModifiedTs !== undefined) {
                localVarQueryParameter['expectedModifiedTs'] = (expectedModifiedTs as any instanceof Date) ?
                    (expectedModifiedTs as any).toISOString() :
                    expectedModifiedTs;
            }

            if (requireExist !== undefined) {
                localVarQueryParameter['requireExist'] = requireExist;
            }

            if (requireNotExist !== undefined) {
                localVarQueryParameter['requireNotExist'] = requireNotExist;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Shutdown
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shutdownDatapusher: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/management/shutdownDatapusher`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManagementApi - functional programming interface
 * @export
 */
export const ManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Empty Config
         * @param {string} schema 
         * @param {SchemaType} schemaType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEmptyConfig(schema: string, schemaType: SchemaType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEmptyConfig(schema, schemaType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.createEmptyConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Pipeline
         * @param {string} pipelineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePipeline(pipelineId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePipeline(pipelineId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.deletePipeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Does Pipeline Exist
         * @param {string} pipelineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doesPipelineExist(pipelineId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doesPipelineExist(pipelineId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.doesPipelineExist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get All Schemas
         * @param {SchemaType} schemaType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSchemas(schemaType: SchemaType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSchemas(schemaType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.getAllSchemas']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Pipeline Config
         * @param {string} pipelineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPipelineConfig(pipelineId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPipelineConfig(pipelineId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.getPipelineConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Pipeline Config Editor
         * @param {string} pipelineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPipelineConfigEditor(pipelineId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPipelineConfigEditor(pipelineId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.getPipelineConfigEditor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Pipelines
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPipelines(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BasicPipelineInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPipelines(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.getPipelines']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Schema
         * @param {string} schema 
         * @param {SchemaType} schemaType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSchema(schema: string, schemaType: SchemaType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSchema(schema, schemaType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.getSchema']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Supported Meter Types
         * @param {SchemaType} schemaType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportedMeterTypes(schemaType: SchemaType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProtocolDescription>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportedMeterTypes(schemaType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.getSupportedMeterTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Parse Config
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parseConfig(body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BasicPipelineInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parseConfig(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.parseConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reload All
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reloadAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reloadAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.reloadAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reload Pipeline
         * @param {string} pipelineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reloadPipeline(pipelineId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reloadPipeline(pipelineId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.reloadPipeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set Pipeline Config
         * @param {string} pipelineId 
         * @param {string} body 
         * @param {string} [expectedModifiedTs] 
         * @param {boolean} [requireExist] 
         * @param {boolean} [requireNotExist] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPipelineConfig(pipelineId: string, body: string, expectedModifiedTs?: string, requireExist?: boolean, requireNotExist?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPipelineConfig(pipelineId, body, expectedModifiedTs, requireExist, requireNotExist, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.setPipelineConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Shutdown
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shutdownDatapusher(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shutdownDatapusher(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApi.shutdownDatapusher']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ManagementApi - factory interface
 * @export
 */
export const ManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ManagementApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Empty Config
         * @param {string} schema 
         * @param {SchemaType} schemaType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmptyConfig(schema: string, schemaType: SchemaType, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createEmptyConfig(schema, schemaType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Pipeline
         * @param {string} pipelineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePipeline(pipelineId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePipeline(pipelineId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Does Pipeline Exist
         * @param {string} pipelineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doesPipelineExist(pipelineId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.doesPipelineExist(pipelineId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get All Schemas
         * @param {SchemaType} schemaType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSchemas(schemaType: SchemaType, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getAllSchemas(schemaType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Pipeline Config
         * @param {string} pipelineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineConfig(pipelineId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getPipelineConfig(pipelineId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Pipeline Config Editor
         * @param {string} pipelineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineConfigEditor(pipelineId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserInfo> {
            return localVarFp.getPipelineConfigEditor(pipelineId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Pipelines
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelines(options?: RawAxiosRequestConfig): AxiosPromise<Array<BasicPipelineInfo>> {
            return localVarFp.getPipelines(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Schema
         * @param {string} schema 
         * @param {SchemaType} schemaType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchema(schema: string, schemaType: SchemaType, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getSchema(schema, schemaType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Supported Meter Types
         * @param {SchemaType} schemaType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedMeterTypes(schemaType: SchemaType, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProtocolDescription>> {
            return localVarFp.getSupportedMeterTypes(schemaType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Parse Config
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseConfig(body: string, options?: RawAxiosRequestConfig): AxiosPromise<BasicPipelineInfo> {
            return localVarFp.parseConfig(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reload All
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reloadAll(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reloadAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reload Pipeline
         * @param {string} pipelineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reloadPipeline(pipelineId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reloadPipeline(pipelineId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set Pipeline Config
         * @param {string} pipelineId 
         * @param {string} body 
         * @param {string} [expectedModifiedTs] 
         * @param {boolean} [requireExist] 
         * @param {boolean} [requireNotExist] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPipelineConfig(pipelineId: string, body: string, expectedModifiedTs?: string, requireExist?: boolean, requireNotExist?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.setPipelineConfig(pipelineId, body, expectedModifiedTs, requireExist, requireNotExist, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Shutdown
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shutdownDatapusher(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.shutdownDatapusher(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ManagementApi - object-oriented interface
 * @export
 * @class ManagementApi
 * @extends {BaseAPI}
 */
export class ManagementApi extends BaseAPI {
    /**
     * 
     * @summary Create Empty Config
     * @param {string} schema 
     * @param {SchemaType} schemaType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public createEmptyConfig(schema: string, schemaType: SchemaType, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).createEmptyConfig(schema, schemaType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Pipeline
     * @param {string} pipelineId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public deletePipeline(pipelineId: string, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).deletePipeline(pipelineId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Does Pipeline Exist
     * @param {string} pipelineId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public doesPipelineExist(pipelineId: string, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).doesPipelineExist(pipelineId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get All Schemas
     * @param {SchemaType} schemaType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public getAllSchemas(schemaType: SchemaType, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).getAllSchemas(schemaType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Pipeline Config
     * @param {string} pipelineId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public getPipelineConfig(pipelineId: string, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).getPipelineConfig(pipelineId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Pipeline Config Editor
     * @param {string} pipelineId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public getPipelineConfigEditor(pipelineId: string, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).getPipelineConfigEditor(pipelineId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Pipelines
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public getPipelines(options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).getPipelines(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Schema
     * @param {string} schema 
     * @param {SchemaType} schemaType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public getSchema(schema: string, schemaType: SchemaType, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).getSchema(schema, schemaType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Supported Meter Types
     * @param {SchemaType} schemaType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public getSupportedMeterTypes(schemaType: SchemaType, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).getSupportedMeterTypes(schemaType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Parse Config
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public parseConfig(body: string, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).parseConfig(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reload All
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public reloadAll(options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).reloadAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reload Pipeline
     * @param {string} pipelineId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public reloadPipeline(pipelineId: string, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).reloadPipeline(pipelineId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set Pipeline Config
     * @param {string} pipelineId 
     * @param {string} body 
     * @param {string} [expectedModifiedTs] 
     * @param {boolean} [requireExist] 
     * @param {boolean} [requireNotExist] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public setPipelineConfig(pipelineId: string, body: string, expectedModifiedTs?: string, requireExist?: boolean, requireNotExist?: boolean, options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).setPipelineConfig(pipelineId, body, expectedModifiedTs, requireExist, requireNotExist, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Shutdown
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagementApi
     */
    public shutdownDatapusher(options?: RawAxiosRequestConfig) {
        return ManagementApiFp(this.configuration).shutdownDatapusher(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VersionApi - axios parameter creator
 * @export
 */
export const VersionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersion: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Version Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersionInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/version/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VersionApi - functional programming interface
 * @export
 */
export const VersionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VersionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVersion(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVersion(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VersionApi.getVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Version Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVersionInfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VersionInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVersionInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VersionApi.getVersionInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VersionApi - factory interface
 * @export
 */
export const VersionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VersionApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersion(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getVersion(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Version Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersionInfo(options?: RawAxiosRequestConfig): AxiosPromise<VersionInfo> {
            return localVarFp.getVersionInfo(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VersionApi - object-oriented interface
 * @export
 * @class VersionApi
 * @extends {BaseAPI}
 */
export class VersionApi extends BaseAPI {
    /**
     * 
     * @summary Get Version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VersionApi
     */
    public getVersion(options?: RawAxiosRequestConfig) {
        return VersionApiFp(this.configuration).getVersion(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Version Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VersionApi
     */
    public getVersionInfo(options?: RawAxiosRequestConfig) {
        return VersionApiFp(this.configuration).getVersionInfo(options).then((request) => request(this.axios, this.basePath));
    }
}



